const React = require("react");
const PropTypes = require("prop-types");

const Description = ({ children }) => (
  <dd className="pane__list-description">{children}</dd>
);

Description.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Description;
